// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (-webkit-min-device-pixel-ratio:0){.profile-details .table th[data-v-2c7671a4],.profile-details .table th .col-4[data-v-2c7671a4]{width:33.33333%;max-width:33.33333%}}.profile-details .table td[data-v-2c7671a4]{padding:0;line-height:35px}", ""]);
// Exports
module.exports = exports;
